class FullWidthToggle {
    constructor(map, options = {}) {
        this.map = map;
        this.on_first_enter = options.on_first_enter || null;
        this.has_entered_full_width = false;
        this.locator = document.querySelector('.pcsl-site-locator');
        this.toggle_button = this.locator.querySelector('.pcsl-site-locator-full-screen-toggle');

        const article = this.locator.closest('article');
        const closest_row = this.locator.closest('.et_pb_row');
        this.container = closest_row || article;

        if(this.container) {
            this._setup_listeners();
            this.update_state();
        }
    }

    toggle() {
        this.locator.classList.toggle('pcsl-full-width');
        if(this.locator.classList.contains('pcsl-full-width')) {
            this.toggle_button.textContent = pcsl_data.labels.exit_full_width;
            this.update_width();
            if (!this.has_entered_full_width) {
                this.has_entered_full_width = true;
                if (this.on_first_enter) this.on_first_enter();
            }
        } else {
            this.toggle_button.textContent = pcsl_data.labels.open_full_width;
            this.reset_width();
        }
    }

    update_width() {
        if(this.locator.classList.contains('pcsl-full-width')) {
            this.toggle_button.textContent = pcsl_data.labels.exit_full_width;
            // Reset margins before measuring so repeated calls (e.g. on resize) get the natural position
            this.locator.style.width = null;
            this.locator.style.maxWidth = null;
            this.locator.style.marginLeft = null;
            this.locator.style.marginRight = null;

            // Use getBoundingClientRect to find how far the locator's left edge is from the container's left edge
            const container_rect = this.container.getBoundingClientRect();
            const locator_rect = this.locator.getBoundingClientRect();
            const offset_from_container = locator_rect.left - container_rect.left;

            this.locator.style.width = `${this.container.offsetWidth}px`;
            this.locator.style.maxWidth = 'none';
            this.locator.style.marginLeft = `-${offset_from_container}px`;
            this.locator.style.marginRight = `-${this.container.offsetWidth - locator_rect.width - offset_from_container}px`;
            
            this.map.resize();
        }
    }

    reset_width() {
        // reset locator width, max-width, and margin-left/margin-right in case it was previously toggled to full width
        this.locator.style.width = null;
        this.locator.style.maxWidth = null;
        this.locator.style.marginLeft = null;
        this.locator.style.marginRight = null;    
        this.map.resize();
    }

    update_state() {
        if(this.should_display()) {
            this.toggle_button.classList.remove('hidden');

            if (this.locator.classList.contains('pcsl-full-width')) {
                this.update_width();
            } else {
                this.reset_width();
            }
        } else {
            this.toggle_button.classList.add('hidden');
            this.locator.classList.remove('pcsl-full-width');
            this.reset_width();
        }
    }

    _setup_listeners() {
        this.toggle_button.addEventListener('click', () => {
            this.toggle();
        });
        window.addEventListener('resize', () => {
            this.update_state();
        });
    }

    should_display() {
        // Check if the closest('.et_pb_row') or the closest('article') tag has a width at least 200px greater than the .pcsl-site-locator element
        if(this.locator.classList.contains('pcsl-full-width')) {
            return true; // If already in full width mode, keep the toggle visible to allow exiting full width
        }
        const container_width = this.container.offsetWidth;
        const locator_width = this.locator.offsetWidth;
        return container_width - locator_width >= 200;
    }
}